import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NEW_PROJECT_DATA, STARTED_LIST_DATA } from "const/services/it-consulting-services";

const ITConsultation = () => {
  return (
    <div className="md:py-16 md:px-8 xl:px-10">
      <div className="w-full flex flex-col xl:flex-row py-12 md:py-0">
        <div className="px-4 md:p-0 w-full xl:w-5/12">
          <h2 className="text-4xl md:text-6xl md:leading-snug font-medium text-black mb-2">
            <span>IT Consultation Service</span>
          </h2>
          <p className="text-base font-normal mr-0 md:mr-4 text-justify">
            <span>
              Taking a third party consultation before starting the product
              development always helps to forecast the scalability, costing and
              product outcome. The first step of consultation starts with
              deciding the correct technology stack and validating your project
              idea with a proper set of research tools and prototyping. You can
              always take care of development with your inhouse people or a
              third party team, but the consultation from the third party
              experts always helps to define a clear path.
            </span>
          </p>
        </div>
        <div className="p-0 w-full xl:w-7/12">
          <div className="mt-8 md:mt-0 flex flex-col md:flex-row md:justify-between xl:justify-end">
            <div className="m-4 md:ml-0 bg-transparent border border-solid border-black/10 rounded-2xl p-8">
              <h3 className="text-2xl font-medium mb-6">
                <span>Starting a New project?</span>
              </h3>
              {NEW_PROJECT_DATA.map((value) => (
                <li
                  key={value.title}
                  className="list-none flex items-center text-base font-normal mb-2"
                >
                  <FontAwesomeIcon
                    className="text-primary-yellow mr-1.5"
                    icon={faCaretRight}
                    width={20}
                    height={20}
                  />
                  <span>{value.title}</span>
                </li>
              ))}
            </div>
            <div className="m-4 md:ml-0 bg-transparent border border-solid border-black/10 rounded-2xl p-8">
              <h3 className="text-2xl font-medium mb-2">
                <span>Already having it started?</span>
              </h3>
              {STARTED_LIST_DATA.map((value) => (
                <li
                  key={value.title}
                  className="list-none flex items-center text-base font-normal mb-6"
                >
                  <FontAwesomeIcon
                    className="text-primary-yellow mr-1.5"
                    icon={faCaretRight}
                    width={20}
                    height={20}
                  />
                  <span>{value.title}</span>
                </li>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ITConsultation;
